import { Link } from 'react-router-dom'
import { routes } from 'src/navigation/routes'
import { BigLink, SubLink } from './components'

export const ParentMenu = ({ user }) => (
  <div className="sidebarHb-wrap">
    <div className="sidebarHb-top">
      <div className="sidebarHb-logo">
        <Link to={routes.root}>
          <img src="/account/img/logo.svg" alt="" />
        </Link>
      </div>
      {/* <i className="hb-ico arrow-left"></i> */}
    </div>
    <div className="sidebarHb-block">
      <div className="sidebarHb-drop">
        <BigLink to={routes.root}>
          <i className="hb-ico sidebarHb-ico-1" />
          Dashboard
          {/* <i className="hb-ico drop-arrow"></i> */}
        </BigLink>
        <ul className="sidebarHb-list">
          <li>
            <SubLink exact to={routes.root}>
              Home
            </SubLink>
          </li>
          <li>
            <SubLink to={routes.dashboard.report_card}>Report card</SubLink>
          </li>
          <li>
            <SubLink to={routes.dashboard.awards}>
              Awards {/* <span>3</span> */}
            </SubLink>
          </li>
        </ul>
      </div>
    </div>
    <div className="sidebarHb-block">
      <div className="sidebarHb-drop">
        <BigLink to={routes.children.index} className="sidebarHb-link">
          <i className="hb-ico sidebarHb-ico-2" />
          Students
          {/* <i className="hb-ico drop-arrow"></i> */}
        </BigLink>
        <ul className="sidebarHb-list">
          {(user.children || []).map((x) => (
            <li key={x.id}>
              <SubLink to={routes.children.show(x.id)}>{x.first_name}</SubLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
    <div className="sidebarHb-block">
      <BigLink to={routes.practices.index} className="sidebarHb-link">
        <i className="hb-ico sidebarHb-ico-3" />
        Assignments
      </BigLink>
    </div>
    <div className="sidebarHb-block">
      <div className="sidebarHb-drop">
        <BigLink to={routes.timetable} className="sidebarHb-link">
          <i className="hb-ico sidebarHb-ico-4" />
          Schedule
          {/* <i className="hb-ico drop-arrow"></i> */}
        </BigLink>
        {/* <ul className="sidebarHb-list">
            <li><SubLink to="/">Practices</SubLink></li>
            <li><SubLink to="/">Tests</SubLink></li>
            <li><SubLink to="/">Chores</SubLink></li>
            <li><SubLink to="/">Training</SubLink></li>
          </ul> */}
      </div>
    </div>
    <div className="sidebarHb-block">
      <div className="sidebarHb-drop">
        <BigLink to={routes.after_school.index}>
          <i className="hb-ico sidebarHb-ico-5" />
          After school
          {/* <i className="hb-ico drop-arrow"></i> */}
        </BigLink>
        <ul className="sidebarHb-list">
          <li>
            <SubLink to={routes.after_school.games.index}>Games</SubLink>
          </li>
          <li>
            <SubLink to={routes.after_school.reading.index}>Reading</SubLink>
          </li>
          <li>
            <SubLink to={routes.after_school.videos.index}>Videos</SubLink>
          </li>
          <li>
            <SubLink to={routes.after_school.chores.index}>Chores</SubLink>
          </li>
          <li>
            <SubLink to={routes.after_school.sport.index}>Sport</SubLink>
          </li>
        </ul>
      </div>
    </div>
    <div className="sidebarHb-block">
      <BigLink to={routes.downloads.index} className="sidebarHb-link">
        <i className="hb-ico sidebarHb-ico-6" />
        Downloads
      </BigLink>
    </div>
    <div className="sidebarHb-block">
      <BigLink to={routes.printables.index} className="sidebarHb-link">
        <i className="hb-ico sidebarHb-ico-7" />
        My Shop
      </BigLink>
    </div>
    <div className="sidebarHb-block">
      <BigLink to={routes.public_lessons.index} className="sidebarHb-link">
        <i className="hb-ico sidebarHb-ico-8" />
        Public lessons
      </BigLink>
    </div>
    <div className="sidebarHb-block">
      <BigLink to={routes.draw}>
        <i className="hb-ico sidebarHb-ico-8" />
        Whiteboard
      </BigLink>
    </div>
  </div>
)
